/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendAdvancedProductConversionFieldDto } from '../../models/backend-advanced-product-conversion-field-dto';

export interface SalesAdvancedProductConversionFieldsList$Params {
  product?: number;

  /**
   * A search term.
   */
  search?: string;
}

export function salesAdvancedProductConversionFieldsList(
  http: HttpClient,
  rootUrl: string,
  params?: SalesAdvancedProductConversionFieldsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendAdvancedProductConversionFieldDto>>> {
  const rb = new RequestBuilder(rootUrl, salesAdvancedProductConversionFieldsList.PATH, 'get');
  if (params) {
    rb.query('product', params.product, {});
    rb.query('search', params.search, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendAdvancedProductConversionFieldDto>>;
    }),
  );
}

salesAdvancedProductConversionFieldsList.PATH = '/api/sales/advanced-product-conversion-fields/';
